const RADIUS = 42;
const PROGRESS_PATH_LENGTH = 100;

export default function CircularProgress({
  value,
  max = 100,
  displayValue,
  label,
  ariaLabel,
  tone = "brand",
  size = "md",
  className = "",
  segments,
}) {
  const numericValue = Number(value);
  const numericMax = Number(max);
  const hasValue = value !== null
    && value !== undefined
    && value !== ""
    && Number.isFinite(numericValue)
    && Number.isFinite(numericMax)
    && numericMax > 0;
  const progress = hasValue ? Math.min(Math.max(numericValue / numericMax, 0), 1) : 0;
  const dashOffset = PROGRESS_PATH_LENGTH * (1 - progress);
  const visibleValue = displayValue ?? (hasValue ? `${Math.round(numericValue)}%` : "-");
  const accessibleLabel = ariaLabel || `${label || "진행률"} ${visibleValue}`;
  const segmentTotal = Array.isArray(segments) && segments.every((segment) =>
    typeof segment?.value === "number" && Number.isFinite(segment.value) && segment.value >= 0)
    ? segments.reduce((sum, segment) => sum + segment.value, 0) : 0;
  const firstSegment = Number.isFinite(segmentTotal) && segmentTotal > 0
    ? segments.find((segment) => segment.value > 0) : null;
  let segmentOffset = 0;

  return (
    <div
      className={`ds-circular-progress ds-circular-progress--${size} ds-circular-progress--${tone}${className ? ` ${className}` : ""}`}
      role="img"
      aria-label={accessibleLabel}
    >
      <svg viewBox="0 0 100 100" aria-hidden="true">
        <circle cx="50" cy="50" r={RADIUS} pathLength={PROGRESS_PATH_LENGTH}
          className={`ds-circular-progress__track${firstSegment ? ` ds-circular-progress__track--segmented ds-circular-progress--${firstSegment.tone || tone}` : ""}`} />
        {segments === undefined ? <circle
          cx="50"
          cy="50"
          r={RADIUS}
          pathLength={PROGRESS_PATH_LENGTH}
          className="ds-circular-progress__indicator"
          strokeDasharray={`${PROGRESS_PATH_LENGTH} ${PROGRESS_PATH_LENGTH}`}
          strokeDashoffset={dashOffset}
        /> : firstSegment ? segments.filter((segment) => segment.value > 0).map((segment, index) => {
          const percentage = segment.value / segmentTotal * PROGRESS_PATH_LENGTH;
          const offset = segmentOffset;
          segmentOffset += percentage;
          // Rotate each dash so small segments never cross the closed-circle seam.
          return (
            <circle key={segment.key ?? index} cx="50" cy="50" r={RADIUS} pathLength={PROGRESS_PATH_LENGTH}
              className={`ds-circular-progress__segment ds-circular-progress--${segment.tone || tone}`}
              strokeDasharray={`${percentage} ${PROGRESS_PATH_LENGTH}`}
              transform={`rotate(${offset * 360 / PROGRESS_PATH_LENGTH} 50 50)`}
            >
              {segment.label ? <title>{segment.label}</title> : null}
            </circle>
          );
        }) : null}
      </svg>
      <span className="ds-circular-progress__content">
        <strong>{visibleValue}</strong>
        {label ? <small>{label}</small> : null}
      </span>
    </div>
  );
}
